import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaClock } from "react-icons/fa";

const unitLabels = {
  seconds: "sec",
  minutes: "min",
  hours: "hr",
  days: "day",
};

export default function DelayNode({ data, selected }) {
  const label = data.duration
    ? `${data.duration} ${unitLabels[data.unit] || data.unit}${data.duration > 1 ? "s" : ""}`
    : null;

  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[180px] transition-shadow ${
        selected ? "border-amber-500 shadow-md" : "border-surface-border"
      }`}
    >
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-amber-500 !border-2 !border-white"
      />

      {/* Header */}
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-amber-500">
        <FaClock size={10} className="text-white" />
        <span className="text-xs font-semibold text-white">Delay</span>
      </div>

      {/* Body */}
      <div className="px-3 py-2.5 text-center">
        {label ? (
          <p className="text-sm font-semibold text-ink-primary">Wait {label}</p>
        ) : (
          <p className="text-xs text-ink-muted italic">Click to set delay</p>
        )}
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !bg-amber-500 !border-2 !border-white"
      />
    </div>
  );
}
